<script>
  import { urlServeur } from "./conf";
  import { onMount } from "svelte";
  import CardPrix from "../components/ihm/CardPrix.svelte";
  import Piechart from "../components/graph/PieChartMD.svelte";
  import Chartd3 from "./graph/D3BulleGraphe.svelte";// Svend3r bibliotheque D3 pour svelte


  let brutRows;
  let axeBricks = ['biencebu','jqhsd'];
  let serieVarLoyer;
  let serieVarAchat;
  let promise;
  let dataNuts = [] ;

  const fetchData =  async () => {
    return fetch(urlServeur + "/api/immeubles/bricksliste")
    .then (response => response.json())
    .then (result => {
        brutRows = result.payload.bricks
        // console.log(brutRows)
        const dataGraph = result.payload.graph;

        if (dataGraph.axes !== "[]") {
        axeBricks = dataGraph.axes.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
        serieVarLoyer = JSON.parse(dataGraph.loyer);
        serieVarAchat = JSON.parse(dataGraph.achat);
        }
        console.log(serieVarLoyer)
        for(let i=0; i < axeBricks.length; i++){
            dataNuts.push({'id': axeBricks[i], 'value': serieVarLoyer[i]})
        }
    })
  };

  /**
   *
   * @param tabLoyers  : object
   * @param pxAchat : Flaot
   */
  const serialTableau = (tabLoyers,pxAchat)=> {
    let  result = []
    let percent = 0

    for(const [key,value] of Object.entries(tabLoyers)){
        if(pxAchat != 0){
            percent = Math.round((value*100/pxAchat)*100)/100
        }else{
            percent = 0
        }
        result.push([key,Math.round(value*100)/100,percent+ ' %'])
    }

    //return  [["ele1",250], ["ele2", 512], ["ele3",684]]
    //console.log(result)
    return result
  }
  /**
   *
   */
  onMount(async () => {
    promise =  fetchData();
  });
</script>

<div class="row">

    <div class="table-responsive col-xl-12">
         <h2>Test Bricks</h2>
        {#if brutRows != undefined}
            {#each brutRows as row}
                <CardPrix
                    cardColor={(row.nom == "Total") ? "green" : "orange"}
                    cardTitle={row.nom}
                    cardPrix={new Intl.NumberFormat("fr-FR").format(Math.round(Math.abs(row.achat)))}
                    cardList={serialTableau(row.loyers,Math.abs(row.achat))}
                />
            {/each}
        {/if}

    </div>

    {#await promise}
    ....
    {:then data}
    {#if (serieVarAchat != undefined)}
    <Chartd3  data ={dataNuts}/>
      <Piechart  chartAxes ={axeBricks} chartDataSets={serieVarAchat} chartLabel="Répartitions des achats"/>
       <Piechart  chartAxes ={axeBricks} chartDataSets={serieVarLoyer} chartLabel="Répartitions des loyers"/>
      {/if}
  {/await}
</div>

